import ServicesTab from "../../../../patient/details/services/ServicesTab";

export default function ServicesDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <ServicesTab inWorkQ={inWorkQ} />
    </div>
}
